export const Loader = () => {
  return (
    <div className='flex flex-col items-center gap-3 h-full w-full justify-center'>
      <div className="w-12 h-12 md:w-16 md:h-16 2xl:w-36 2xl:h-36 rounded-full animate-spin border-8 border-t-violet-500 border-gray-300 shadow-md"></div>
      <p className='text-xl'>טוען מידע</p>
    </div>
  )
}

export const APIloader = async (request, params) => {
    if(!request)
        return false; // no request, no data

    const url = new URL(request.url);
    if(url.pathname.length < 1)
        return false;

    // set API endpoint
    const endpoint = new URL(`https://${process.env.REACT_APP_API_ENDPOINT}/api.php`);

    // convert pathname to searchParams
    if(url.pathname !== '/') {
        const path = url.pathname.split('/');
        for(let i = 1; i < path.length; i++) { // i = 1 to skip the first empty string
            if(i === 1)
                endpoint.searchParams.append('method', path[i]);
            else
                endpoint.searchParams.append(path[i], 1);
        }
    }

    if(params) {
        for(const [key, val] of Object.entries(params)) {
            endpoint.searchParams.has(key) ? endpoint.searchParams.set(key, val) : endpoint.searchParams.append(key, val);
        }
    }

    let formData = null;
    const method = request.method === 'POST' ? 'POST' : 'GET';
    if(method === 'POST') {
        formData = await request.formData();
        const formBody = new URLSearchParams(formData);
        formData = formBody.toString();
    }
    
    const options = {
        method: method,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData
    };

    const token = sessionStorage.getItem('accessToken');
    if(token)
        options.headers.Authorization = `Bearer ${token}`;

    const response = await fetch(endpoint, options);
    if(!response.ok)
        throw new Error('אין אפשרות לקבל מידע מהשרת');

    const data = await response.json();

    // refresh token if expired
    if(data.errorCode && data.errorCode >= 100 && data.errorCode <= 110) {
        const res = await requestNewToken();
        if(res) {
            options.headers.Authorization = `Bearer ${sessionStorage.getItem('accessToken')}`;
            return await fetch(endpoint, options); // retry request
        } else {
            sessionStorage.clear();
            localStorage.removeItem('refreshToken');
            return false;
        }
    }

    return data;
}

const requestNewToken = async () => {
    console.log('Refreshing token...');
    const refreshToken = localStorage.getItem('refreshToken');
    if(!refreshToken)
        return false;
    
    const userType = localStorage.getItem('userType');
    if(!userType)
        return false;

    const request = new Request('/user/refresh', {method: 'POST', body: new URLSearchParams({type: userType, token: refreshToken})});
    const res = await fetch(request);
    if(res && res.token && res.refresh) {
        sessionStorage.setItem('accessToken', res.token);
        localStorage.setItem('refreshToken', res.refresh);
        if(res.name)
            sessionStorage.setItem('userName', res.name);

        return true;
    }

    return false;
}

export const DoubleTap = (callback) => {
    return (event) => {
        const now = Date.now();
        const lastTap = parseInt(event.currentTarget.dataset.lastTap || 0, 10);
        if(now - lastTap < 300) { // double-tap detected
            console.log('Double tap detected');
            event.preventDefault();
            callback(event);
        } else {
            event.currentTarget.dataset.lastTap = now;
        }   
    }
};
